exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/User/Documents/sujay/crpanel/crpanel/backend/backend/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/User/Documents/sujay/crpanel/crpanel/backend/backend/node_modules/postcss-loader?{"ident":"postcss"}!C:/Users/User/Documents/sujay/crpanel/crpanel/backend/backend/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!C:/Users/User/Documents/sujay/crpanel/crpanel/backend/backend/src/scss/style.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/scss/style.scss
// module chunks = styles